export default "__VITE_ASSET__CQUBOp32__"